import { render, staticRenderFns } from "./brand-and-model.vue?vue&type=template&id=ad49bfa6&"
import script from "./brand-and-model.vue?vue&type=script&lang=ts&"
export * from "./brand-and-model.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports